export default {
  type: "equipment-transfer-items",
  equipment: {
    type: "equipments",
    id: null,
  },
  relationshipNames: [
    "equipment",
    "transfer",
  ],
  quantity: 1,
};
